export default __webpack_public_path__ + "static/media/img2.7168b930.jpg";